import MessageTypeList from './MessageTypeList';
import MessageTypeEdit from './MessageTypeEdit';
import MessageTypeCreate from './MessageTypeCreate';

export default {
  name: 'whatsapp_message_type',
  list: MessageTypeList,
  edit: MessageTypeEdit,
  create: MessageTypeCreate,
};
